/* ===========================================================================
   Modale location native (LLD) — comportement.
   Remplace l'iframe /apps/greenleaze-proxy/modal-cart sur la fiche produit.

   - Les prix par durée viennent de window.Greenleaze.locationPrices
     (map { duration: { monthly, initial } }), exposée par
     greenleaze-abonnement-product.liquid, source = getAllPricesForProduct().
   - La soumission réutilise le handler existant « submitGreenleazeModal »
     (postMessage) qui gère déjà submitRentalFlow / sendCartAndRedirect + FMD.
   - Bascule éditeur : data-gl-loc-devices (none/desktop/mobile/both), lu à
     chaque ouverture. Le déclencheur (greenleaze-abonnement-product.liquid)
     n'appelle open() que si le device est ciblé ; on revérifie ici par sûreté.
   =========================================================================== */
(function () {
  'use strict';

  // NB : pas de « return » global ici. Un tel garde bloquait la ré-exécution du
  // script (hot-reload / re-render de section) et empêchait la ré-attache des
  // listeners délégués. On ne garde qu'un flag ciblé sur l'attache (voir plus bas).

  // Marqueur de version — pour vérifier en prod que ce JS est bien à jour :
  //   window.__glLocVersion  → doit renvoyer 'direct-bind-1'
  window.__glLocVersion = 'mobile-accordion-2';

  var MODAL_ID = 'greenleaze-location-modal';
  var INSURANCE_MONTHLY = 7; // € / mois, option assurance vol & casse (cosmétique, cf. recompute)
  var APPORT_RANGE = 500; // amplitude minimale du curseur au-dessus de l'apport minimum réel
  // Apport cible sur les vélos en TVA sur marge (20 % du prix affiché du vélo, cf. mail
  // Greenleaze du 28/08/2026) : plancher du curseur sur ces vélos, et borne que le curseur
  // doit pouvoir atteindre sur les autres (sur un vélo cher, +500 € n'y suffisent pas).
  // Le taux CANONIQUE vit dans greenleaze-script.js (MARGIN_VAT_DEPOSIT_RATE), d'où les
  // mensualités « Dès X €/mois » de la fiche tirent le MÊME plancher — sans quoi la fiche
  // réaffiche le montant à apport par défaut, plus élevé que celui de cette modale.
  // Relu à l'appel et non au chargement : ce script est `defer`, greenleaze-script.js `async`.
  function apportTargetRate() {
    var rate = window.Greenleaze && window.Greenleaze.marginVatDepositRate;
    return typeof rate === 'number' && rate > 0 ? rate : 0.2;
  }
  // Plafond du curseur en % du prix affiché : réglage éditeur (greenleaze_location_apport_max_rate,
  // porté par data-gl-loc-apport-max-rate sur le curseur). Il ne joue que s'il dépasse
  // plancher + APPORT_RANGE. Absent ou invalide, on retombe sur l'apport cible (20 %).
  function apportMaxRate(slider) {
    var raw = slider && slider.dataset ? parseFloat(slider.dataset.glLocApportMaxRate) : NaN;
    return isNaN(raw) || raw < 0 ? apportTargetRate() : raw / 100;
  }
  // Durée mise en avant à l'ouverture, location comme financements : les trois solutions
  // se comparent alors à durée égale. Sans elle, la location partait sur 36 mois (sa plus
  // longue durée) face à un Younited sur 84 mois — deux mensualités incomparables.
  var PREFERRED_MONTHS = 36;
  var triggerBtn = null;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  // Mise en page mobile = le seuil du CSS (@media max-width: 860px), d'où dépendent
  // le plein écran ET l'accordéon (location repliée à l'ouverture). Toujours relu, pour
  // suivre une rotation d'écran ou un redimensionnement.
  function isMobileLayout() {
    return window.matchMedia('(max-width: 860px)').matches;
  }

  // --- Bascule par appareil (lue à chaque ouverture, jamais mise en cache) ---
  function isEnabledForDevice(modal) {
    if (!modal) return false;
    var devices = modal.dataset.glLocDevices || 'none';
    if (devices === 'none') return false;
    if (devices === 'both') return true;
    return devices === 'mobile' ? isMobileLayout() : !isMobileLayout();
  }

  // --- Formatage ---
  function frNumber(n) {
    if (n == null || isNaN(n)) return '—';
    return Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
  }

  function frEuro(n) {
    if (n == null || isNaN(n)) return '—';
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  // --- Données prix : { duration: { monthly, initial } }, durées réelles ---
  function getPriceMap() {
    var raw = (window.Greenleaze && window.Greenleaze.locationPrices) || {};
    var map = {};
    Object.keys(raw).forEach(function (k) {
      var d = parseInt(k, 10);
      // On écarte la sentinelle « 1 mois » (non proposée en location) et les durées nulles.
      if (!d || d <= 1) return;
      var rule = raw[k] || {};
      map[d] = {
        monthly: Number(rule.monthly) || 0,
        initial: Number(rule.initial) || 0,
      };
    });
    return map;
  }

  function sortedDurations(map) {
    return Object.keys(map)
      .map(function (k) {
        return parseInt(k, 10);
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  // Une durée explicitement demandée (choix fait dans la buybox) reste prioritaire ;
  // à défaut la durée mise en avant, et en dernier recours la plus longue disponible,
  // soit la mensualité la plus basse.
  function pickDefaultDuration(durations, requested) {
    if (requested && durations.indexOf(requested) !== -1) return requested;
    if (durations.indexOf(PREFERRED_MONTHS) !== -1) return PREFERRED_MONTHS;
    return durations[durations.length - 1];
  }

  // --- Rendu ---
  function renderDurations(modal, durations, selected) {
    var wrap = modal.querySelector('[data-gl-loc-durations]');
    if (!wrap) return;
    wrap.innerHTML = '';
    durations.forEach(function (d) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gl-loc-modal__duration-btn';
      if (d === selected) btn.classList.add('gl-loc-modal__duration-btn--selected');
      btn.setAttribute('data-gl-loc-duration', String(d));
      btn.setAttribute('data-cta-name', 'location_duree_' + d);
      btn.setAttribute('aria-pressed', d === selected ? 'true' : 'false');
      btn.textContent = d + ' mois';
      wrap.appendChild(btn);
    });
  }

  function setText(modal, selector, value) {
    var el = modal.querySelector(selector);
    if (el) el.textContent = value;
  }

  // Intitulé de section enrichi de la sélection courante (« La location longue
  // durée — 36 mois »). Le libellé de base est celui rendu par le Liquid, mémorisé
  // au premier passage pour rester la source de vérité — et pouvoir y revenir.
  function setEyebrow(modal, key, suffix) {
    var el = modal.querySelector('[data-gl-loc-eyebrow="' + key + '"]');
    if (!el) return;
    if (!el.dataset.glLocEyebrowBase) el.dataset.glLocEyebrowBase = el.textContent.trim();
    var base = el.dataset.glLocEyebrowBase;
    el.textContent = suffix ? base + ' — ' + suffix : base;
  }

  function eurosInt(n) {
    if (n == null || isNaN(n)) return '—';
    return Math.round(n) + ' €';
  }

  // Vélo en TVA sur marge : variante dont « Facturer les taxes » (chargeTaxes) est décoché,
  // exposé par greenleaze-abonnement-product.liquid. Ces vélos partent sur un apport de 20 %
  // du prix affiché plutôt que sur l'apport Greenleaze par défaut (mail GL du 28/08/2026).
  function isMarginVat() {
    return !!(window.Greenleaze && window.Greenleaze.locationMarginVat);
  }

  // Le curseur d'apport n'a de sens que si la mensualité peut suivre : il faut à la fois
  // les règles brutes (placeholder [[additionalDepositTTC]], cf. /pricing?raw=true) et la
  // fonction de calcul du script Greenleaze. À défaut on masque le curseur plutôt que
  // d'afficher un montant qui ne bougerait pas — l'apport minimum reste affiché au récap.
  function apportSupported() {
    return (
      !!(window.Greenleaze && window.Greenleaze.supportsAdditionalDeposit) &&
      typeof window.getRuleByProductPriceAndDuration === 'function' &&
      !!(window.Greenleaze && window.Greenleaze.locationPriceHT)
    );
  }

  function syncApportAvailability(modal) {
    var wrap = modal.querySelector('.gl-loc-modal__apport');
    if (!wrap) return; // réglage « curseur d'apport » décoché : le bloc n'est même pas rendu
    var ok = apportSupported();

    // Échappatoire pour travailler l'UI avant que le back ne serve les règles brutes. La
    // mensualité reste alors FIGÉE quand on bouge le curseur : visuel uniquement, jamais
    // pour valider un montant.
    if (!ok && window.greenleazeDebug) {
      console.warn("[gl-loc] curseur d'apport forcé (greenleazeDebug) — la mensualité ne suivra pas.");
      ok = true;
    }

    // Sans ce message, un curseur activé en éditeur de thème mais absent à l'écran n'a
    // aucune explication : le réglage semble simplement ne rien faire. On dit LAQUELLE des
    // trois conditions manque — sinon on accuse le back alors que c'est parfois seulement le
    // prix du produit, pas encore exposé par greenleaze-abonnement-product.liquid.
    if (!ok) {
      var gl = window.Greenleaze || {};
      console.warn(
        "[gl-loc] curseur d'apport masqué malgré le réglage — la mensualité ne pourrait pas suivre le curseur.\n" +
          '  règles brutes ([[additionalDepositTTC]]) : ' +
          (gl.supportsAdditionalDeposit ? 'ok' : 'MANQUANT') +
          '\n  getRuleByProductPriceAndDuration : ' +
          (typeof window.getRuleByProductPriceAndDuration === 'function' ? 'ok' : 'MANQUANT') +
          '\n  Greenleaze.locationPriceHT : ' +
          (gl.locationPriceHT || 'MANQUANT') +
          '\n  → Greenleaze.debugPricing() affiche la query et sa réponse ; ' +
          "window.greenleazeDebug = true force l'affichage du curseur.",
      );
    }

    wrap.hidden = !ok;
  }

  // Mensualité et apport pour un supplément d'apport donné, calculés par les RÈGLES
  // Greenleaze elles-mêmes plutôt que par une formule maison.
  //
  // L'approximation précédente — monthly = m0 - (A - a0) / durée — était fausse : sur
  // l'exemple Greenleaze (vélo à 2000 €, supplément de 400 €, 36 mois) elle donne 44,39 €
  // là où Greenleaze facture 44,07 €, soit un supplément amorti sur 35 mois et non 36 — le
  // premier étant réglé à la signature. Le diviseur exact appartient aux règles : on les
  // interroge au lieu de les rejouer, et le jour où Greenleaze le change, rien à retoucher ici.
  function priceForDeposit(duration, extra) {
    if (!apportSupported()) return null;
    try {
      return window.getRuleByProductPriceAndDuration(
        window.Greenleaze.locationPriceHT,
        duration,
        extra > 0 ? extra : 0,
      );
    } catch (e) {
      console.error('[gl-loc] calcul de l\'apport impossible:', e);
      return null;
    }
  }

  function isInsured(modal) {
    var cb = modal.querySelector('[data-gl-loc-insurance]');
    return !!(cb && cb.checked);
  }

  // Applique une durée : borne le curseur d'apport sur le vrai apport (initial issu des
  // règles Greenleaze) jusqu'à +APPORT_RANGE, remet le curseur au minimum, puis recalcule.
  function applyDuration(modal, duration) {
    var rule = getPriceMap()[duration];
    if (!rule) return;
    // NB : l'état vit sous `glLocCurrentDuration`, PAS `glLocDuration` — ce dernier
    // est le marqueur de clic des boutons de durée. Les confondre ferait remonter
    // closest('[data-gl-loc-duration]') jusqu'à la racine pour tout clic de la modale,
    // court-circuitant les autres branches de la délégation.
    modal.dataset.glLocCurrentDuration = String(duration);

    var slider = modal.querySelector('[data-gl-loc-apport-slider]');
    if (slider) {
      var base = rule.initial;
      var displayed = (window.Greenleaze && window.Greenleaze.locationPriceDisplayed) || 0;
      var target = Math.round(displayed * apportTargetRate());

      // Plancher : l'apport Greenleaze par défaut, SAUF sur les vélos en TVA sur marge
      // (variante non taxable, cf. locationMarginVat) où l'apport cible de 20 % devient le
      // minimum — c'est ce qui garde la 1re mensualité compétitive sur ces vélos. Le
      // supplément envoyé à Greenleaze reste calculé depuis `base` (cf. submit) : le
      // plancher déplace le point de départ du curseur, pas la référence Greenleaze.
      // 🔴 Le calcul est CANONIQUE dans greenleaze-script.js (getDisplayDepositFloor) et
      // partagé avec les mensualités « Dès X €/mois » de la fiche : le dupliquer ici ferait
      // revivre la divergence fiche/modale que ce partage corrige. Repli sur le calcul local
      // si le CDN sert encore un greenleaze-script.js antérieur à cet ajout.
      var newMin = base;
      if (typeof window.getDisplayDepositFloor === 'function') {
        newMin = window.getDisplayDepositFloor(base, displayed, isMarginVat());
      } else if (isMarginVat()) {
        newMin = Math.max(base, target);
      }

      // Plafond : +APPORT_RANGE au-dessus du plancher, mais jamais moins que le % maximum
      // réglé dans l'éditeur (20 % par défaut) — au-delà de ~2 500 € de vélo, +500 € ne
      // suffisent pas à atteindre les 20 %.
      var newMax = Math.max(newMin + APPORT_RANGE, Math.round(displayed * apportMaxRate(slider)));
      var prev = parseFloat(slider.value);
      // glLocDur effacé (à chaque ouverture, cf. open()) => première application : apport mini.
      var isFirst = !slider.dataset.glLocDur;

      slider.min = String(newMin);
      slider.max = String(newMax);
      slider.step = '1';

      // Changement de durée : on CONSERVE l'apport choisi, borné au nouveau range
      // (min/max dépendent de la durée). On ne le remet au mini qu'à l'ouverture.
      var next = isFirst || isNaN(prev) ? newMin : Math.min(Math.max(prev, newMin), newMax);
      slider.value = String(next);
      slider.dataset.glLocDur = String(duration);
    }
    recompute(modal);
  }

  // Recalcule tous les montants depuis la durée courante, le curseur d'apport et l'assurance,
  // à partir des règles GL (rule.monthly = m0, rule.initial = a0 pour la durée d).
  //
  // Mensualité dynamique : déléguée aux règles Greenleaze via priceForDeposit(), à qui l'on
  // passe le SUPPLÉMENT d'apport (A - a0). À A = a0 le supplément vaut 0 et l'on retrouve
  // exactement la mensualité Greenleaze. (+7 €/mois si assurance cochée.)
  //
  // NB : l'apport est désormais transmis à send-card (additionnalInitialDeposit, cf. submit),
  // donc la page de réservation GL affiche la même mensualité que la modale. L'assurance,
  // elle, reste cosmétique : le back ne la reçoit pas.
  function recompute(modal) {
    var duration = parseInt(modal.dataset.glLocCurrentDuration, 10);
    var rule = getPriceMap()[duration];
    if (!rule || !duration) return;

    var slider = modal.querySelector('[data-gl-loc-apport-slider]');
    var base = rule.initial; // a0
    var apport = slider ? parseFloat(slider.value) || base : base; // A
    var ins = isInsured(modal) ? INSURANCE_MONTHLY : 0;

    // Remplissage vert de la piste, à gauche du curseur (WebKit : dégradé piloté en CSS).
    if (slider) {
      var sMin = parseFloat(slider.min) || 0;
      var sMax = parseFloat(slider.max) || sMin + 1;
      var pct = sMax > sMin ? ((apport - sMin) / (sMax - sMin)) * 100 : 0;
      slider.style.setProperty('--gl-loc-fill', pct + '%');
    }

    var priced = priceForDeposit(duration, apport - base);
    var monthly = (priced ? priced.monthly : rule.monthly) + ins;
    if (monthly < 0) monthly = 0;
    monthly = Math.round(monthly * 100) / 100;

    // Le marquage n'entre pas dans le « à payer aujourd'hui » : il ne fait pas partie du
    // contrat de location et n'est pas transmis à Greenleaze (cf. stripMarquage dans
    // greenleaze-script.js). Il reste au panier Shopify pour le parcours achat.
    // La livraison, elle, s'y ajoute — montant indicatif réglé dans les settings.
    var delivery = (parseInt(modal.dataset.glLocDeliveryCents, 10) || 0) / 100;
    var today = apport + monthly + delivery;

    setText(modal, '[data-gl-loc-monthly]', frNumber(monthly));
    setText(modal, '[data-gl-loc-apport]', frEuro(apport));
    setText(modal, '[data-gl-loc-today]', frEuro(today));
    setText(modal, '[data-gl-loc-line-apport]', frEuro(apport));
    setText(modal, '[data-gl-loc-line-monthly]', frEuro(monthly));

    // Intitulés : la durée choisie, dans la section comme dans la barre récap.
    setEyebrow(modal, 'lld', duration + ' mois');
    setEyebrow(modal, 'bar', duration + ' mois');

    // Ligne livraison masquée si le réglage vaut 0.
    var deliveryLine = modal.querySelector('[data-gl-loc-line-delivery]');
    if (deliveryLine) {
      deliveryLine.hidden = delivery <= 0;
      if (delivery > 0) setText(modal, '[data-gl-loc-line-delivery-value]', frEuro(delivery));
    }

    // Échelle sous le curseur : bornes réelles du curseur (cf. applyDuration) — donc le
    // plancher 20 % sur les vélos en TVA sur marge, et non l'apport Greenleaze de référence.
    setText(modal, '[data-gl-loc-apport-min]', eurosInt(slider ? parseFloat(slider.min) || base : base));
    setText(
      modal,
      '[data-gl-loc-apport-max]',
      eurosInt(slider ? parseFloat(slider.max) || base + APPORT_RANGE : base + APPORT_RANGE),
    );

    // Valeur de la ligne assurance uniquement (l'ouverture/fermeture de la ligne est
    // gérée par le handler de la case, PAS ici : bouger l'apport ne doit rien y changer).
    if (ins > 0) setText(modal, '[data-gl-loc-line-insurance-value]', frEuro(INSURANCE_MONTHLY));

    // Le bandeau reste affiché pendant que la location est dépliée (accordéon mobile) :
    // il doit donc suivre chaque recalcul, et pas seulement le moment du repli.
    paintLldBar(modal);
  }

  // Bandeau récap de la location : durée + mensualité courantes. Lit ce qui vient
  // d'être écrit dans la section plutôt que de refaire le calcul — une seule source.
  function paintLldBar(modal) {
    if (!modal.querySelector('[data-gl-loc-lld-bar]')) return;
    var monthly = modal.querySelector('[data-gl-loc-monthly]');
    setText(modal, '[data-gl-loc-bar-monthly]', (monthly ? monthly.textContent : '—') + ' €');
    // « sur N mois » : même formulation que le libellé des cartes Alma / Younited
    // (offerLabel), pour que les trois bandeaux se lisent de la même façon.
    var duration = parseInt(modal.dataset.glLocCurrentDuration, 10);
    setText(modal, '[data-gl-loc-bar-label]', duration ? 'sur ' + duration + ' mois' : '—');
  }

  function selectDuration(modal, duration) {
    modal.querySelectorAll('[data-gl-loc-duration]').forEach(function (btn) {
      var active = parseInt(btn.dataset.glLocDuration, 10) === duration;
      btn.classList.toggle('gl-loc-modal__duration-btn--selected', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    applyDuration(modal, duration);
  }

  function populate(modal, requestedDuration) {
    var map = getPriceMap();
    var durations = sortedDurations(map);
    if (!durations.length) return false;
    var selected = pickDefaultDuration(durations, requestedDuration);
    renderDurations(modal, durations, selected);
    syncApportAvailability(modal);
    applyDuration(modal, selected);
    return true;
  }

  // --- Focus trap (calqué sur reserve-modal.js) ---
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var modal = getModal();
    if (!modal) return;
    var all = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var focusable = Array.prototype.filter.call(all, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      // La lecture masquée de la modale Alma peut émettre un Escape pour la
      // refermer : il ne doit pas emporter la modale de location avec lui.
      var fin = window.GreenleazeFinancing;
      if (fin && typeof fin.isScraping === 'function' && fin.isScraping()) return;
      close();
    } else {
      trapFocus(e);
    }
  }

  // --- Widget Trustpilot : init explicite (la modale est hidden au chargement,
  //     le bootstrap Trustpilot ne la scanne pas → on force loadFromElement). ---
  function initTrustpilot(modal) {
    var widget = modal.querySelector('.trustpilot-widget');
    if (!widget) return;
    if (widget.dataset.glLocTpDone === '1') return;
    var tries = 0;
    (function load() {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        try {
          window.Trustpilot.loadFromElement(widget, true);
          widget.dataset.glLocTpDone = '1';
        } catch (e) {}
        return;
      }
      if (tries++ < 50) window.setTimeout(load, 200); // script async : ~10 s max
    })();
  }

  // --- Verrou de défilement ---------------------------------------------------
  // `overflow: hidden` sur <body> laisse Safari iOS faire défiler la page derrière
  // la modale. On fige donc le body (position: fixed, cf. CSS) en compensant par un
  // décalage négatif, puis on restaure la position à la fermeture.
  var scrollLockY = 0;

  function lockScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = -scrollLockY + 'px';
    document.documentElement.classList.add('gl-loc-modal-is-open');
  }

  function unlockScroll() {
    var html = document.documentElement;
    html.classList.remove('gl-loc-modal-is-open');
    document.body.style.top = '';

    // Le thème pose `scroll-behavior: smooth` globalement : sans neutralisation,
    // la remise en place serait animée depuis le haut de page. On la désactive le
    // temps du saut plutôt que de compter sur `behavior: 'instant'`, moins bien
    // supporté sur les Safari anciens — précisément les navigateurs visés ici.
    var previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, scrollLockY);
    html.style.scrollBehavior = previous;
  }

  // --- Ouverture / fermeture ---
  //
  // opts : { duration, variantId, trigger, financing }
  //   - duration   : durée de location pré-sélectionnée (mois) ;
  //   - variantId  : variante concernée, mémorisée sur la modale ;
  //   - trigger    : élément à re-focaliser à la fermeture (a11y) ;
  //   - financing  : { provider, installments } — ouvre DIRECTEMENT le configurateur
  //                  de ce prestataire sur cette échéance, en sautant la vue location.
  //                  Utilisé par le widget Alma de la fiche produit. Émet alors
  //                  `location_<provider>_direct` (et NON `location_<provider>`, réservé
  //                  au clic sur « Configurer ») — cf. requestFinancing.
  // Renvoie false si la modale n'est pas rendue, si l'appareil n'est pas ciblé par le
  // réglage, ou si aucun prix n'est disponible : l'appelant doit alors se replier.
  function open(opts) {
    opts = opts || {};
    var modal = getModal();
    if (!modal) return false;
    if (!isEnabledForDevice(modal)) return false;
    if (!modal.hidden) {
      // Déjà ouverte : on honore quand même une demande de configurateur — ignorer le
      // clic serait pire qu'un simple changement d'onglet.
      requestFinancing(modal, opts.financing);
      return true;
    }

    // Chaque ouverture repart de l'apport minimum : on efface le marqueur de durée
    // du curseur pour que populate() le réinitialise (cf. garde dans applyDuration).
    var slider = modal.querySelector('[data-gl-loc-apport-slider]');
    if (slider) delete slider.dataset.glLocDur;

    // Assurance décochée + ligne repliée à chaque ouverture (état = la case).
    var insCb = modal.querySelector('[data-gl-loc-insurance]');
    if (insCb) insCb.checked = false;
    var insLine = modal.querySelector('[data-gl-loc-line-insurance]');
    if (insLine) insLine.classList.remove('is-open');

    var ok = populate(modal, Number(opts.duration) || undefined);
    if (!ok) return false; // pas de prix dispo → on laisse le fallback iframe agir

    // Chaque ouverture repart de la location : aucun configurateur déplié.
    // Les offres d'appel mémorisées sont conservées — les vider ici ne rafraîchirait
    // rien (Younited est relu à chaque appel, Alma est mémorisé pour la page) et
    // ferait repartir sur une relecture qui peut échouer. L'invalidation se fait au
    // changement de variante, seul moment où les montants changent réellement.
    clearFinancing(modal);

    // Affiche uniquement les prestataires qui ont réellement des montants à montrer.
    syncOtherSolutions(modal);

    // MOBILE : la location s'ouvre REPLIÉE derrière son bandeau, pour que les trois
    // solutions tiennent dans le premier écran (décision utilisateur 2026-07-31) — le
    // configurateur complet occupait sinon toute la hauteur à lui seul. Desktop
    // inchangé : la location y reste dépliée d'emblée.
    //
    // INCONDITIONNEL, et c'est le point : cet état de départ était conditionné au
    // résultat de syncOtherSolutions, donc à des widgets tiers pas forcément chargés au
    // moment du clic. Un clic rapide ouvrait la location dépliée alors que personne ne
    // l'avait demandée (mesuré le 2026-08-03 : widgets privés de données à l'ouverture →
    // location dépliée, puis cartes révélées en dessous). La mise en page ne doit pas
    // dépendre d'une course de chargement. Le cas « aucune autre solution », où le repli
    // ne laisserait qu'un bandeau à cliquer, est rattrapé par watchOtherSolutions une
    // fois les prestataires départagés (cf. expandLldIfAlone).
    var startCollapsed = isMobileLayout();
    // Après clearFinancing ci-dessus, qui a déplié : c'est ici que l'état de départ est
    // arrêté, donc ici qu'on dit si la location a réellement été montrée.
    lldSeen = startCollapsed === false;
    if (startCollapsed) setLldCollapsed(modal, true);

    // Complète la carte Alma en arrière-plan (lecture masquée de sa modale).
    prefetchAlma(modal);

    // Logos officiels clonés depuis les widgets (repli typographique en attendant), et
    // rattrapage des prestataires dont le widget n'avait encore rien publié au clic.
    watchOtherSolutions(modal);

    // Liaison directe des CTA Louer / En savoir plus (bypass total de la délégation).
    bindDirectControls(modal);

    if (opts.variantId) modal.dataset.glLocVariantId = opts.variantId;
    triggerBtn = opts.trigger || null;

    modal.hidden = false;
    lockScroll();
    document.addEventListener('keydown', handleKeydown);
    initTrustpilot(modal);

    window.requestAnimationFrame(function () {
      modal.focus();
    });

    // Ouverture directe sur un configurateur (clic sur une échéance du widget Alma de
    // la fiche). Posée EN DERNIER, une fois l'état de départ arrêté : plus haut,
    // clearFinancing() et setLldCollapsed() la déferaient aussitôt.
    requestFinancing(modal, opts.financing);

    return true;
  }

  // Ferme la modale. Sans argument, ferme TOUTE instance .gl-loc-modal ouverte
  // (robuste si la page contient plusieurs rendus de product-template → doublons d'id).
  function close(modal) {
    var list = modal ? [modal] : Array.prototype.slice.call(document.querySelectorAll('.gl-loc-modal'));
    var closedAny = false;
    list.forEach(function (m) {
      if (!m || m.hidden) return;
      m.hidden = true;
      closedAny = true;
    });
    if (!closedAny) return;
    window.clearTimeout(watchTimer);
    unlockScroll();
    document.removeEventListener('keydown', handleKeydown);
    if (triggerBtn && typeof triggerBtn.focus === 'function') {
      triggerBtn.focus();
    }
    triggerBtn = null;
  }

  // Paramètres FMD (thème) pour send-card, lus sur le bouton buybox — sans jamais throw.
  function buildThemeParams() {
    if (!document.body.hasAttribute('is-fmd')) return undefined;
    var btn = document.querySelector('.greenleaze-button-product');
    if (!btn) return undefined;
    return {
      bannerArg1: btn.dataset.reduction,
      bannerArg2: btn.dataset.partner,
      additionnalLogo: btn.dataset.logo,
      type: btn.dataset.type,
    };
  }

  // --- Soumission : ouvre la modale de réservation Greenleaze ---
  function submit(modal) {
    var duration = parseInt(modal.dataset.glLocCurrentDuration, 10) || undefined;
    // variantId déjà connu à l'ouverture ; fallbacks robustes sinon.
    var trigger = document.querySelector('.greenleaze-button-product');
    var variantId =
      modal.dataset.glLocVariantId ||
      new URLSearchParams(window.location.search).get('variant') ||
      (trigger ? trigger.dataset.variantId : null);

    // Apport choisi dans la modale native. Deux transmissions, à ne pas confondre :
    //   - `additionnalInitialDeposit` ci-dessous : le SUPPLÉMENT (A - a0), lu par l'API
    //     Greenleaze, qui pilote réellement l'apport et la mensualité du contrat ;
    //   - `themeParams.apport` / le query param `apport` : le TOTAL, best-effort, purement
    //     indicatif — n'a d'effet que si le back les lit.
    // L'assurance, elle, reste cosmétique de bout en bout.
    var slider = modal.querySelector('[data-gl-loc-apport-slider]');
    var apportVal = slider ? parseFloat(slider.value) : NaN;
    var insured = isInsured(modal);
    window.Greenleaze = window.Greenleaze || {};
    window.Greenleaze.locationApport = isNaN(apportVal) ? null : apportVal;
    window.Greenleaze.locationInsurance = insured;
    window.Greenleaze.locationDuration = duration != null ? duration : null;

    // Supplément d'apport au-delà de l'apport Greenleaze par défaut de la durée retenue.
    // L'API l'attend par variante — d'où le garde-fou sur variantId : sans lui, aucun
    // produit à qui rattacher l'apport, on n'envoie rien plutôt que de l'appliquer au hasard.
    // `duration` est exigée : sans elle, aucune règle à interroger, donc pas d'apport de
    // référence — le supplément se confondrait avec l'apport total et doublerait la mise.
    var deposits = null;
    var baseApport = duration ? (getPriceMap()[duration] || {}).initial || 0 : 0;
    var extraApport = !duration || isNaN(apportVal) ? 0 : Math.round((apportVal - baseApport) * 100) / 100;

    // Deux lectures coexistent dans leurs mails du 28/08 : Hippolyte décrit un
    // `additionnalInitialDeposit` qui est un SUPPLÉMENT (« ajouter un apport de 200 € »),
    // Stéphane un `initialDeposit` « de 20 % du prix du vélo », donc un TOTAL. On envoie le
    // supplément (l'API Shopify, celle qu'on appelle, est celle d'Hippolyte) ; le flag console
    // `greenleazeDepositAsTotal = true` bascule sur le total pour tester l'autre lecture,
    // à combiner avec `greenleazeDepositKeys = ['initialDeposit']`.
    var asTotal = !!window.greenleazeDepositAsTotal && !isNaN(apportVal);
    var depositAmount = asTotal ? apportVal : extraApport;

    if (depositAmount > 0 && variantId) {
      deposits = {};
      deposits[String(variantId)] = depositAmount;
    } else if (depositAmount > 0) {
      // Le client a bougé le curseur mais on n'a aucune variante à qui rattacher l'apport :
      // il ne partira pas, et la page Greenleaze affichera l'apport par défaut. Warning non
      // conditionné à greenleazeDebug — c'est un écart silencieux entre ce que la modale
      // promet et ce qui est facturé, il doit se voir sans avoir rien armé au préalable.
      console.warn(
        "[gl-loc] apport de " +
          depositAmount +
          " € NON transmis : aucune variante identifiée (dataset glLocVariantId, ?variant= et " +
          '.greenleaze-button-product[data-variant-id] sont tous absents).',
      );
    }

    // Trace inspectable APRÈS COUP : la modale se ferme et la réservation s'ouvre par-dessus,
    // mais on reste sur la même page — `Greenleaze.lastRentalSubmit` en console suffit donc à
    // savoir ce qui est parti, sans avoir eu à poser greenleazeDebug avant le clic. À
    // confronter à `Greenleaze.lastSendCard` (ce que la requête a réellement porté).
    window.Greenleaze.lastRentalSubmit = {
      duration: duration,
      variantId: variantId,
      apportChoisi: isNaN(apportVal) ? null : apportVal,
      apportBaseGreenleaze: baseApport,
      supplementEnvoye: extraApport,
      montantEnvoye: depositAmount,
      envoyeEnTantQue: asTotal ? 'TOTAL (greenleazeDepositAsTotal)' : 'supplément',
      additionnalInitialDeposit: deposits,
    };
    if (window.greenleazeDebug) console.log('[gl-loc] soumission location :', window.Greenleaze.lastRentalSubmit);

    close(modal);

    // submitRentalFlow → startReservation ouvre #modal-reservation--greenleaze (loader +
    // iframe bookingUrl) quand la nouvelle version est active (lld_new_version_devices).
    if (window.Greenleaze && typeof window.Greenleaze.submitRentalFlow === 'function') {
      var themeParams = buildThemeParams() || {};
      if (window.Greenleaze.locationApport != null) themeParams.apport = window.Greenleaze.locationApport;
      themeParams.insurance = insured;
      window.Greenleaze.submitRentalFlow({
        duration: duration,
        variantId: variantId,
        themeParams: themeParams,
        additionnalInitialDeposit: deposits,
      });
      return;
    }

    // Repli : ancien handler global (redirection / réservation selon config).
    window.postMessage({ type: 'submitGreenleazeModal', duration: duration }, window.location.origin);
  }

  // ==========================================================================
  // Autres solutions (Alma / Younited)
  //
  // Les montants viennent de greenleaze-financing-data.js, qui encapsule le
  // markup des widgets tiers. Deux niveaux de lecture, pour ne rien payer avant
  // que l'utilisateur ne le demande :
  //   - la carte affiche une mensualité lisible immédiatement (Younited expose
  //     ses offres en JS ; Alma, son widget replié) ;
  //   - le récap détaillé n'est chargé qu'au clic sur « Configurer » — côté Alma
  //     il faut ouvrir sa modale d'éligibilité (masquée), donc jamais d'office.
  // ==========================================================================

  var PROVIDERS = ['alma', 'younited'];
  var finState = { provider: null, offers: [], index: 0 };

  // Échéance choisie par l'utilisateur, par prestataire. Survit à « Revoir la
  // location » : la carte continue de l'afficher et rouvrir le configurateur y
  // revient, au lieu de repartir sur l'offre d'appel. Purgée au changement de
  // variante, où les montants ne veulent plus rien dire.
  var finSelection = { alma: null, younited: null };

  // Échéance RÉCLAMÉE par un appelant externe — le widget Alma de la fiche produit
  // (assets/product-essentials-alma.js) ouvre la modale directement sur le plan cliqué.
  // Distinct de `finSelection` : c'est une intention à consommer UNE fois, pas une
  // préférence à mémoriser. Elle prime sur la sélection mémorisée le temps d'une
  // ouverture, puis s'efface — sans quoi rouvrir la modale par un autre chemin
  // (« Financer », bandeau) atterrirait éternellement sur le plan d'un clic ancien.
  // On n'y stocke qu'un NOMBRE d'échéances, jamais un objet Offer : les offres sont
  // reconstruites à chaque lecture, et un faux Offer partiel casserait paintCard
  // (`syncOtherSolutions` lit `offer.monthly` sur ce que contient finSelection).
  var finRequested = { alma: null, younited: null };

  function financingApi() {
    return window.GreenleazeFinancing || null;
  }

  function deliveryOf(modal) {
    return (parseInt(modal.dataset.glLocDeliveryCents, 10) || 0) / 100;
  }

  // Renseigne les cartes et masque celles dont le prestataire n'a rien à dire.
  // Libellé d'une offre : Alma raisonne en échéances, Younited en mensualités.
  // Partagé par la carte et l'intitulé de section, pour qu'ils ne divergent jamais.
  function offerLabel(offer) {
    return offer.provider === 'alma' ? 'en ' + offer.installments + '×' : 'sur ' + offer.installments + ' mois';
  }

  // Pose le logo officiel dans la pastille, en remplacement du repli typographique.
  // Renvoie true si la carte a son logo (ou n'en attend plus), false s'il faut
  // retenter — les widgets rendent de façon asynchrone.
  function paintLogo(modal, provider) {
    var holder = modal.querySelector('[data-gl-loc-solution="' + provider + '"] [data-gl-loc-other-logo]');
    if (!holder) return true;
    if (holder.classList.contains('has-logo')) return true;

    var api = financingApi();
    var node = api && typeof api.logo === 'function' ? api.logo(provider) : null;
    if (!node) return false;

    // Le nom de marque, masqué visuellement, porte déjà l'information : le logo
    // n'a rien à annoncer de plus.
    node.setAttribute('aria-hidden', 'true');
    holder.appendChild(node);
    holder.classList.add('has-logo');
    return true;
  }

  // --- Rattrapage des widgets tiers arrivés après le clic --------------------
  //
  // Alma et Younited sont chargés en async par leurs apps. Une lecture UNIQUE à
  // l'ouverture laissait la carte du widget encore muet masquée pour toute la durée de
  // l'ouverture, sans jamais y revenir : d'où « je n'ai qu'Alma, ou que Younited, et au
  // rafraîchissement les deux » — cache chaud = widgets prêts avant le clic, cache froid
  // ou clic rapide = course perdue. Mesuré le 2026-08-03 (welt-g80) : widgets rendus
  // 2,5 s après l'ouverture, les DEUX cartes toujours masquées.
  // On relit donc jusqu'à ce que les deux prestataires se soient prononcés. Le
  // rattrapage des logos, qui suivait déjà ce patron, est absorbé ici.
  var WATCH_INTERVAL_MS = 200;
  var WATCH_MAX_TRIES = 25; // ~5 s : le temps qu'un widget tiers rende sur réseau lent
  var watchTimer = null;

  // Signature des cartes visibles : sert à détecter l'apparition d'une carte en cours
  // de route, seul cas qui demande de réévaluer l'accordéon.
  function visibleSolutions(modal) {
    return PROVIDERS.filter(function (p) {
      var card = modal.querySelector('[data-gl-loc-solution="' + p + '"]');
      return !!card && !card.hidden;
    }).join(',');
  }

  // Un prestataire est établi quand il a livré son offre d'appel ET son logo — ou quand
  // sa carte n'est pas rendue du tout. paintLogo peint au passage (il retourne false
  // tant que le widget n'a pas rendu), comme le faisait initLogos.
  function providerSettled(modal, api, provider) {
    var card = modal.querySelector('[data-gl-loc-solution="' + provider + '"]');
    if (!card) return true;
    return headlineOffer(api, provider) != null && paintLogo(modal, provider);
  }

  // Filet du repli mobile : une fois les prestataires départagés, si AUCUNE autre
  // solution n'est affichable, la location repliée ne laisserait qu'un bandeau à
  // cliquer — on la déplie. C'est le seul cas où le repli mobile n'a pas de sens ; dès
  // qu'une carte est visible, il reste l'état voulu. Le repli étant désormais posé sans
  // attendre les widgets, ce filet peut mettre jusqu'à WATCH_MAX_TRIES × 200 ms à
  // conclure — délai théorique : sur un vélo louable, Alma comme Younited couvrent
  // toujours la gamme de prix, donc au moins une carte finit par s'afficher.
  function expandLldIfAlone(modal) {
    if (modal.hidden || !isMobileLayout()) return;
    if (visibleSolutions(modal) !== '') return;
    if (finState.provider) return; // un configurateur pilote déjà l'affichage
    var lld = modal.querySelector('[data-gl-loc-lld]');
    if (lld && lld.classList.contains('is-collapsed')) setLldCollapsed(modal, false);
  }

  function watchOtherSolutions(modal) {
    window.clearTimeout(watchTimer);
    var tries = 0;

    (function attempt() {
      var api = financingApi();
      var settled = PROVIDERS.every(function (p) {
        return providerSettled(modal, api, p);
      });
      if (settled || tries++ >= WATCH_MAX_TRIES) {
        expandLldIfAlone(modal);
        return;
      }

      watchTimer = window.setTimeout(function () {
        if (modal.hidden) return; // refermée entre-temps : plus rien à surveiller
        var before = visibleSolutions(modal);
        syncOtherSolutions(modal);
        prefetchAlma(modal);
        // Une carte qui apparaît en cours de route change la donne pour l'accordéon
        // mobile : le bandeau de la location en devient l'en-tête (cf. barStaysVisible).
        // On réévalue sa visibilité dans l'état courant, sans y toucher autrement.
        if (visibleSolutions(modal) !== before) {
          var lld = modal.querySelector('[data-gl-loc-lld]');
          setLldCollapsed(modal, !!lld && lld.classList.contains('is-collapsed'));
        }
        attempt();
      }, WATCH_INTERVAL_MS);
    })();
  }

  // Écrit le montant et le libellé d'une carte. Appelé à l'ouverture (offre d'appel)
  // puis à chaque changement d'échéance, pour que la carte reflète toujours ce qui
  // est réellement configuré en dessous.
  function paintCard(modal, provider, monthly, label) {
    var card = modal.querySelector('[data-gl-loc-solution="' + provider + '"]');
    if (!card) return;
    var amount = card.querySelector('[data-gl-loc-other-monthly]');
    if (amount && monthly != null) amount.textContent = frEuro(monthly);
    var labelEl = card.querySelector('[data-gl-loc-other-label]');
    if (labelEl && label) labelEl.textContent = label;
  }

  // Offres Alma complètes, mémorisées dès qu'on a pu lire sa modale : elles seules
  // permettent d'afficher son plan le plus long (le widget replié, lui, n'expose
  // que le plan actif).
  var almaOffers = null;

  function longestOffer(offers) {
    return (offers || []).reduce(function (acc, o) {
      if (o.monthly == null || !o.installments) return acc;
      return acc == null || o.installments > acc.installments ? o : acc;
    }, null);
  }

  // Échéance mise en avant : la même durée que la location (PREFERRED_MONTHS), pour que
  // les trois bandeaux se lisent côte à côte sans comparer 36 mois à 84. À défaut — Alma
  // plafonne à quelques échéances, Younited peut ne pas couvrir la durée — la plus longue
  // disponible, soit la mensualité la plus basse.
  function defaultOffer(offers) {
    var preferred = (offers || []).filter(function (o) {
      return o.monthly != null && o.installments === PREFERRED_MONTHS;
    })[0];
    return preferred || longestOffer(offers);
  }

  // Dernière offre d'appel connue par prestataire. Indispensable : syncOtherSolutions
  // est rejoué au retour à la location, et une relecture peut échouer ponctuellement
  // (widget tiers re-rendu, texte momentanément vide). Sans mémoire, la carte
  // disparaîtrait alors que le prestataire est toujours disponible.
  var headlineCache = { alma: null, younited: null };

  function headlineOffer(api, provider) {
    if (!api) return headlineCache[provider];

    var offer = null;
    if (provider === 'younited') {
      offer = defaultOffer(api.younited().offers);
    } else {
      // Offres complètes si déjà lues, sinon le plan actif du widget replié.
      offer = defaultOffer(almaOffers);
      if (!offer) {
        var inline = api.almaInline();
        if (inline && inline.monthly != null) offer = inline;
      }
    }

    if (offer) headlineCache[provider] = offer;
    return offer || headlineCache[provider];
  }

  // Charge les offres Alma en arrière-plan pour que sa carte annonce, elle aussi, le
  // plan mis en avant. Mémorisé par greenleaze-financing-data.js : une seule lecture
  // par page. Sans effet si l'utilisateur a déjà ouvert un configurateur entre-temps.
  //
  // Le drapeau évite d'empiler les appels quand la relecture périodique
  // (watchOtherSolutions) repasse toutes les 200 ms avant la fin de la lecture.
  var almaPrefetching = false;

  function prefetchAlma(modal) {
    var api = financingApi();
    if (!api || almaOffers || almaPrefetching) return;
    // AUCUNE garde sur `card.hidden` : une carte masquée signifie justement qu'aucune
    // offre d'appel n'était lisible — c'est LE cas que ce préchargement doit rattraper.
    // L'y abandonner condamnait Alma pour toute la durée de l'ouverture (mesuré le
    // 2026-08-03 : widget rendu 2,5 s après le clic, carte restée masquée).
    var card = modal.querySelector('[data-gl-loc-solution="alma"]');
    if (!card) return;

    almaPrefetching = true;
    api.alma().then(function (res) {
      almaPrefetching = false;
      if (!res || !res.available || !res.offers.length) return;
      almaOffers = res.offers;
      if (finState.provider) return; // un configurateur pilote déjà l'affichage
      // syncOtherSolutions et pas paintCard : la carte peut être masquée, il faut la
      // révéler ET peindre son montant du même geste.
      syncOtherSolutions(modal);
    });
  }

  // Renvoie true si au moins un prestataire est affichable : l'accordéon mobile n'a
  // de sens qu'à cette condition (cf. barStaysVisible / repli initial dans open()).
  function syncOtherSolutions(modal) {
    var section = modal.querySelector('[data-gl-loc-others]');
    if (!section) return false;
    var api = financingApi();
    var any = false;

    PROVIDERS.forEach(function (p) {
      var card = modal.querySelector('[data-gl-loc-solution="' + p + '"]');
      if (!card) return;

      // Sélection de l'utilisateur si elle existe, offre d'appel sinon.
      var offer = finSelection[p] || headlineOffer(api, p);
      card.hidden = offer == null;
      if (offer == null) return;
      any = true;
      paintCard(modal, p, offer.monthly, offerLabel(offer));
    });

    section.hidden = !any;
    return any;
  }

  // --- Repli de la location au profit du configurateur ---
  //
  // En MOBILE le bandeau reste affiché même location dépliée : il sert d'en-tête
  // d'accordéon, seul chemin pour revenir à la vue « les trois solutions d'un coup ».
  // Sans autre solution à côté, l'accordéon n'aurait qu'une section : le bandeau
  // n'apporterait rien et on garde le comportement desktop (visible seulement replié).
  function barStaysVisible(modal) {
    if (!isMobileLayout()) return false;
    var others = modal.querySelector('[data-gl-loc-others]');
    return !!others && !others.hidden;
  }

  // La location a-t-elle été affichée depuis l'ouverture ? Seul « Revoir » l'exige.
  // Piloté par setLldCollapsed, puis réinitialisé par open() une fois l'état de départ
  // connu : en desktop la location est visible d'emblée, en mobile elle est repliée et
  // n'a donc jamais été vue — dire « Revoir » y serait faux.
  var lldSeen = false;

  // Durée d'animation lue dans le CSS : une seule source de vérité pour la valeur (le
  // token --gl-loc-accordion-duration), et `prefers-reduced-motion` (0 s) est respecté
  // sans condition supplémentaire ici.
  function transitionMs(el) {
    var declared = getComputedStyle(el).transitionDuration || '0s';
    var seconds = declared.split(',').reduce(function (max, part) {
      var value = parseFloat(part) || 0;
      if (part.indexOf('ms') !== -1) value /= 1000;
      return Math.max(max, value);
    }, 0);
    return seconds * 1000;
  }

  // Anime le repli/dépliage sur la hauteur RÉELLE du contenu, jamais sur un plafond
  // arbitraire : c'est ce qui rendait l'animation heurtée (cf. le commentaire de
  // .gl-loc-modal__section[data-gl-loc-lld] dans le CSS, avec les mesures).
  // La hauteur est relue à chaque animation — le contenu varie (assurance, ligne
  // livraison, durée) — et le style inline est retiré à l'arrivée pour que la section
  // reste libre de grandir au repos.
  function animateSection(el, collapsed) {
    var from = el.getBoundingClientRect().height;
    var to = 0;

    if (collapsed === false) {
      // Hauteur naturelle : mesurée dans l'état d'arrivée, transition coupée, puis
      // retour à l'état de départ. Sans cette coupure, la mesure s'animerait elle-même.
      el.classList.add('is-measuring');
      el.style.maxHeight = 'none';
      el.classList.remove('is-collapsed');
      to = el.getBoundingClientRect().height;
      el.classList.add('is-collapsed');
      el.style.maxHeight = from + 'px';
      void el.offsetHeight; // fige l'état de départ avant de rendre la transition
      el.classList.remove('is-measuring');
    } else {
      // Repli : la hauteur de départ doit être explicite, sinon il n'y a rien à
      // interpoler depuis `max-height` absent.
      el.style.maxHeight = from + 'px';
      void el.offsetHeight;
    }

    el.classList.toggle('is-collapsed', collapsed);
    el.style.maxHeight = to + 'px';

    // Nettoyage par minuteur plutôt que par `transitionend` : celui-ci ne se déclenche
    // pas quand la transition est coupée (prefers-reduced-motion) ni quand la distance
    // est nulle, ce qui laisserait une hauteur figée en inline.
    window.clearTimeout(el.__glLocAnimTimer);
    el.__glLocAnimTimer = window.setTimeout(
      function () {
        el.style.maxHeight = '';
      },
      transitionMs(el) + 60,
    );
  }

  function setLldCollapsed(modal, collapsed) {
    if (!collapsed) lldSeen = true;
    var lld = modal.querySelector('[data-gl-loc-lld]');
    var bar = modal.querySelector('[data-gl-loc-lld-bar]');
    if (lld) {
      // Rien à animer si l'état demandé est déjà celui en place : setLldCollapsed est
      // appelé aussi pour de simples resynchronisations (resize, syncOtherSolutions),
      // qui n'ont pas à provoquer de reflow ni de transition.
      if (lld.classList.contains('is-collapsed') !== collapsed) {
        if (modal.hidden) {
          // Modale encore fermée (état de départ posé par open()) : tout est à 0 dans
          // un `display: none`, une animation y serait dégénérée — et l'utilisateur ne
          // doit de toute façon rien voir bouger à l'ouverture.
          window.clearTimeout(lld.__glLocAnimTimer);
          lld.style.maxHeight = '';
          lld.classList.toggle('is-collapsed', collapsed);
        } else {
          animateSection(lld, collapsed);
        }
      }
      // La section repliée reste dans le flux (max-height: 0 + overflow, pas de
      // display: none) : sans `inert`, tous ses contrôles resteraient atteignables au
      // clavier alors qu'ils sont invisibles — d'autant plus gênant en mobile, où c'est
      // l'état d'ouverture. toggleAttribute plutôt que .inert : ignoré sans dommage par
      // les navigateurs qui ne le connaissent pas, au lieu d'être un expando muet.
      lld.toggleAttribute('inert', collapsed);
    }
    if (!bar) return;

    bar.hidden = collapsed ? false : !barStaysVisible(modal);
    bar.classList.toggle('is-open', !collapsed);
    paintLldBar(modal);

    // Le libellé nomme l'action du PROCHAIN clic, et data-cta-name la suit pour que le
    // dataLayer distingue ouvrir/replier (trackCta lit l'attribut avant que l'action
    // n'ait lieu). « Revoir » suppose de l'avoir déjà vue — sinon « Voir ».
    var cta = bar.querySelector('.gl-loc-modal__lld-bar-cta');
    var label = 'Réduire';
    var ctaName = 'location_reduire_location';
    if (collapsed) {
      label = lldSeen ? 'Revoir la location' : 'Voir la location';
      ctaName = 'location_revoir_location';
    }
    if (cta) cta.textContent = label;
    bar.setAttribute('data-cta-name', ctaName);
  }

  // --- Rendu du panneau ---
  function renderFinDurations(modal, offers, index) {
    var wrap = modal.querySelector('[data-gl-loc-fin-durations]');
    if (!wrap) return;
    wrap.innerHTML = '';
    offers.forEach(function (offer, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gl-loc-modal__duration-btn';
      if (i === index) btn.classList.add('gl-loc-modal__duration-btn--selected');
      btn.setAttribute('data-gl-loc-fin-duration', String(i));
      btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      btn.textContent = offer.installments + '×';
      wrap.appendChild(btn);
    });
  }

  // Affiche une ligne du récap si la donnée existe, la masque sinon — les deux
  // prestataires n'exposent pas les mêmes champs.
  function setFinLine(modal, key, value) {
    var line = modal.querySelector('[data-gl-loc-fin-line="' + key + '"]');
    if (!line) return;
    var ok = typeof value === 'number' && !isNaN(value) && value > 0;
    line.hidden = !ok;
    // La valeur est REMISE À « — » quand la ligne se masque, au lieu d'être laissée en
    // place. Ceinture et bretelles : c'est le CSS qui doit masquer (règle
    // `.gl-loc-modal__today-line[hidden]`), mais si elle venait à sauter — c'est
    // exactement ce qui est arrivé le 2026-08-05 —, on afficherait au pire un tiret, et
    // jamais le montant d'une AUTRE échéance, ce qui est un mensonge sur une offre de
    // crédit.
    setText(modal, '[data-gl-loc-fin-value="' + key + '"]', ok ? frEuro(value) : '—');
  }

  var PROVIDER_NAMES = { alma: 'Alma', younited: 'Younited' };

  function renderFinRecap(modal, offer) {
    if (!offer) return;

    // La carte reprend l'échéance configurée : sans ça elle continuerait d'annoncer
    // l'offre d'appel, en contradiction avec le récap juste en dessous.
    paintCard(modal, offer.provider, offer.monthly, offerLabel(offer));
    setEyebrow(modal, 'others', (PROVIDER_NAMES[offer.provider] || offer.provider) + ' ' + offerLabel(offer));
    var delivery = deliveryOf(modal);
    var down = typeof offer.downPayment === 'number' ? offer.downPayment : 0;
    var first = typeof offer.firstAmount === 'number' ? offer.firstAmount : 0;

    setText(modal, '[data-gl-loc-fin-monthly]', frNumber(offer.monthly));
    // « sur N mois » pour les deux : Alma parle d'échéances en interne, mais le
    // client raisonne en mois, et ses plans sont mensuels.
    setText(modal, '[data-gl-loc-fin-months]', 'sur ' + offer.installments + ' mois');
    setText(modal, '[data-gl-loc-fin-today]', frEuro(down + first + delivery));

    setFinLine(modal, 'downPayment', offer.downPayment);
    setFinLine(modal, 'firstAmount', offer.firstAmount);
    setFinLine(modal, 'delivery', delivery);
    setFinLine(modal, 'financed', offer.financed);
    setFinLine(modal, 'cost', offer.cost);
    setFinLine(modal, 'total', offer.total);

    // Mention légale : le TAEG doit accompagner toute offre de crédit affichée.
    var note = modal.querySelector('[data-gl-loc-fin-note]');
    if (note) {
      note.textContent =
        typeof offer.taeg === 'number' && offer.taeg > 0
          ? 'TAEG fixe de ' +
            frNumber(offer.taeg) +
            ' %. Un crédit vous engage et doit être remboursé. ' +
            'Vérifiez vos capacités de remboursement avant de vous engager.'
          : '';
    }
  }

  function selectFinDuration(modal, index) {
    var offer = finState.offers[index];
    if (!offer) return;
    finState.index = index;
    finSelection[offer.provider] = offer;
    renderFinDurations(modal, finState.offers, index);
    renderFinRecap(modal, offer);
  }

  // --- Sélection d'un prestataire (carte = onglet) ---
  function paintTabs(modal, provider) {
    PROVIDERS.forEach(function (p) {
      var card = modal.querySelector('[data-gl-loc-solution="' + p + '"]');
      if (!card) return;
      card.classList.toggle('is-active', p === provider);
      card.classList.toggle('is-dimmed', provider != null && p !== provider);
      var tab = card.querySelector('[data-gl-loc-financing]');
      if (tab) tab.setAttribute('aria-expanded', p === provider ? 'true' : 'false');
    });

    var panel = modal.querySelector('[data-gl-loc-fin-panel]');
    if (!panel) return;
    panel.hidden = provider == null;
    PROVIDERS.forEach(function (p) {
      panel.classList.toggle('gl-loc-modal__fin--from-' + p, p === provider);
    });
  }

  // `keepCollapsed` : referme le financement SANS déplier la location. Refermer une
  // solution n'est pas demander l'autre — l'accordéon revient à « tout replié », toutes
  // les options visibles côte à côte. Sans ce paramètre, re-cliquer « Configurer »
  // dépliait la location, qu'on n'avait pas demandée.
  function clearFinancing(modal, keepCollapsed) {
    var had = finState.provider;
    // Une intention non consommée (lecture des offres en échec) ne doit pas survivre à
    // la fermeture du configurateur : elle détournerait la prochaine ouverture.
    finRequested = { alma: null, younited: null };
    paintTabs(modal, null);
    // Repli AVANT la purge de finState : le libellé du bandeau distingue « Revoir la
    // location » (elle a bien été quittée pour un financement) de « Voir la location ».
    setLldCollapsed(modal, keepCollapsed === true);
    finState = { provider: null, offers: [], index: 0 };
    setEyebrow(modal, 'others', null);
    // Les cartes reprennent leur offre d'appel. Inutile à l'ouverture, où
    // syncOtherSolutions s'en charge juste après.
    if (had) syncOtherSolutions(modal);
  }

  function openFinancing(modal, provider) {
    // Re-cliquer l'onglet actif le referme (comportement d'accordéon) — et referme
    // SEULEMENT lui : la location reste repliée derrière son bandeau, prête à être
    // ouverte d'un clic si c'est bien ce que l'on veut.
    if (finState.provider === provider) {
      clearFinancing(modal, true);
      return;
    }

    var api = financingApi();
    if (!api) return;

    var lld = modal.querySelector('[data-gl-loc-lld]');
    var wasExpanded = !!lld && lld.classList.contains('is-collapsed') === false;

    paintTabs(modal, provider);
    // finState AVANT le repli : setLldCollapsed lit `finState.provider` pour choisir
    // entre « Voir » et « Revoir la location » sur le bandeau.
    finState = { provider: provider, offers: [], index: 0 };
    setLldCollapsed(modal, true);

    var load = function () {
      if (provider === 'younited') return Promise.resolve(api.younited());
      return api.alma().then(function (res) {
        // Repli sur la lecture inline si la modale Alma n'a rien donné.
        if (res.available) return res;
        var inline = api.almaInline();
        return inline ? { available: true, offers: [inline] } : res;
      });
    };

    // Lecture des offres différée jusqu'à la fin du repli, et SEULEMENT si un repli est
    // réellement en cours : côté Alma il faut parser sa modale d'éligibilité, ~106 ms de
    // thread principal sur mobile modeste, qui volaient les premières frames de
    // l'animation (mesuré le 2026-07-31, CPU 4× : première frame peinte à 229 ms contre
    // 108 ms quand le repli vient du bandeau). Une animation de hauteur n'est pas
    // compositée : tout travail JS pendant ces 300 ms se voit. Location déjà repliée
    // (cas courant en mobile) → aucun délai, la durée vaut 0.
    var settleMs = wasExpanded ? transitionMs(lld) : 0;

    var apply = function (res) {
      // L'utilisateur a pu changer d'onglet pendant le chargement Alma.
      if (finState.provider !== provider) return;
      finState.offers = res.offers || [];
      if (!finState.offers.length) {
        // Lecture en échec : on annule l'ouverture. En vue accordéon on ne déplie pas
        // la location pour autant (elle n'a pas été demandée) ; en desktop, où le
        // bandeau seul ne mène à rien, on la remet en place comme avant.
        clearFinancing(modal, barStaysVisible(modal));
        return;
      }
      // On retrouve l'échéance voulue par son nombre d'échéances, et non par son
      // index : les offres sont reconstruites à chaque lecture, donc l'objet mémorisé
      // n'est jamais le même que celui du tableau courant.
      // Priorité : l'échéance réclamée pour CETTE ouverture (clic sur le widget Alma de
      // la fiche) > la sélection mémorisée > l'offre mise en avant. Consommée ici, donc
      // sans effet sur les ouvertures suivantes.
      var wanted = finRequested[provider];
      finRequested[provider] = null;
      if (wanted == null && finSelection[provider]) wanted = finSelection[provider].installments;

      var index = -1;
      if (wanted != null) {
        for (var i = 0; i < finState.offers.length; i++) {
          if (finState.offers[i].installments === wanted) {
            index = i;
            break;
          }
        }
      }
      // À défaut, l'échéance mise en avant — la même que celle annoncée par la carte,
      // sinon ouvrir le configurateur changerait le montant sous les yeux.
      if (index < 0) {
        var fallback = defaultOffer(finState.offers);
        index = fallback ? finState.offers.indexOf(fallback) : finState.offers.length - 1;
      }
      selectFinDuration(modal, index);
    };

    window.setTimeout(function () {
      // L'onglet a pu changer pendant l'attente : on ne lance même pas la lecture.
      if (finState.provider !== provider) return;
      load().then(apply);
    }, settleMs);
  }

  // Ouvre d'emblée le configurateur d'un prestataire, sur une échéance donnée.
  // Appelée par open() pour le compte du widget Alma de la fiche produit : cliquer
  // « 3x » dans la buybox doit atterrir sur le récap du 3x, pas sur l'offre d'appel.
  // `financing` = { provider: 'alma'|'younited', installments: Number }. `installments`
  // est FACULTATIF : sans lui (ou si le prestataire ne propose pas cette échéance),
  // openFinancing retombe sur l'offre mise en avant — jamais d'ouverture à vide.
  function requestFinancing(modal, financing) {
    if (!financing || PROVIDERS.indexOf(financing.provider) === -1) return;
    var provider = financing.provider;
    var count = parseInt(financing.installments, 10);
    finRequested[provider] = isNaN(count) ? null : count;

    // Tracking — ouverture PROGRAMMATIQUE du configurateur : le bouton « Configurer »
    // n'étant pas cliqué, son `location_<provider>` n'est jamais émis. On pousse donc un
    // nom DISTINCT (`location_alma_direct`), pour que les deux entrées du configurateur
    // restent séparables dans le dataLayer — compter les ouvertures totales = somme des
    // deux events, jamais l'un seul.
    // `installments` est l'échéance DEMANDÉE : si le prestataire ne la propose pas,
    // l'affichage retombera sur l'offre mise en avant (cf. `apply`), l'event garde
    // l'intention.
    // Émis AVANT openFinancing et seulement si le configurateur s'ouvre réellement :
    // redemander celui déjà ouvert le REFERME (accordéon), ce n'est pas une ouverture.
    if (finState.provider !== provider) {
      pushCta(modal, 'location_' + provider + '_direct', { installments: isNaN(count) ? null : count });
    }

    openFinancing(modal, provider);
  }

  // --- CTA : ajout au panier puis checkout ---
  // Alma comme Younited sont des moyens de paiement au checkout Shopify : on ne
  // peut pas les présélectionner, d'où un libellé neutre. Le marquage, lui, est
  // bien inclus ici (contrairement au parcours Greenleaze).
  function goToCheckout(modal, button) {
    var variantId =
      modal.dataset.glLocVariantId ||
      new URLSearchParams(window.location.search).get('variant') ||
      (document.querySelector('.greenleaze-button-product') || {}).dataset?.variantId;
    if (!variantId) return;

    if (button) button.disabled = true;
    var routes = (window.theme && window.theme.routes) || {};

    // Nature du CTA pour l'add_to_cart : le configurateur ouvert porte le provider
    // (finState.provider, pose par openFinancing). Alma et Younited partagent ce
    // meme bouton, seul finState les distingue.
    window.__mintAtcType = finState.provider === 'younited' ? 'younited' : 'alma';

    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function () {
        var sync = window.theme && window.theme.cart && window.theme.cart.syncMarquage;
        return typeof sync === 'function' ? sync() : null;
      })
      .catch(function (e) {
        console.error('[location] ajout panier échoué', e);
      })
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  // --- Tracking : dataLayer click_cta pour tout [data-cta-name] de la modale ---
  // `extra` : champs additionnels, ignorés s'ils sont nuls (une clé présente mais vide
  // vaut une donnée fausse dans le dataLayer).
  function pushCta(modal, name, extra) {
    if (!name || !window.dataLayer) return;
    var payload = {
      event: 'click_cta',
      cta_name: name,
      cta_location: modal.getAttribute('data-cta-location') || 'greenleaze_location_modal',
      variant_id: modal.dataset.glLocVariantId || '',
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        if (extra[key] != null) payload[key] = extra[key];
      });
    }
    window.dataLayer.push(payload);
  }

  function trackCta(modal, el) {
    pushCta(modal, el.getAttribute('data-cta-name'));
  }

  // --- Délégation des clics (sur document : survit aux re-renders de la section
  //     produit, qui remplaceraient un listener posé sur le nœud de la modale) ---
  function onModalClick(e) {
    if (!e.target || !e.target.closest) return;
    var modal = e.target.closest('.gl-loc-modal');
    if (!modal) return; // clic hors modale

    var ctaEl = e.target.closest('[data-cta-name]');
    if (ctaEl && modal.contains(ctaEl)) trackCta(modal, ctaEl);

    if (e.target.closest('[data-gl-loc-close]')) {
      close(modal);
      return;
    }
    var durBtn = e.target.closest('[data-gl-loc-duration]');
    if (durBtn) {
      selectDuration(modal, parseInt(durBtn.dataset.glLocDuration, 10));
      return;
    }
    var finDurBtn = e.target.closest('[data-gl-loc-fin-duration]');
    if (finDurBtn) {
      selectFinDuration(modal, parseInt(finDurBtn.dataset.glLocFinDuration, 10));
      return;
    }
    if (e.target.closest('[data-gl-loc-lld-bar]')) {
      // Bandeau replié → on revient à la location, ce qui referme tout configurateur
      // de financement ouvert (comportement d'accordéon, seul cas atteignable en
      // desktop où le bandeau n'est visible que dans cet état).
      // Bandeau déplié (mobile only) → repli manuel, sans toucher aux financements :
      // on retrouve les trois bandeaux côte à côte.
      var lldSection = modal.querySelector('[data-gl-loc-lld]');
      if (lldSection && lldSection.classList.contains('is-collapsed') === false) {
        setLldCollapsed(modal, true);
      } else {
        clearFinancing(modal);
      }
      return;
    }
    // Carte Alma / Younited cliquable SUR TOUTE SA SURFACE — mobile uniquement, où elle
    // devient un bandeau d'accordéon au même titre que celui de la location (lui-même un
    // <button> pleine surface). En desktop la carte reste une carte : seul son CTA agit.
    // Les clics SUR le CTA sont exclus : il porte sa propre liaison directe
    // (bindDirectControls) et openFinancing bascule — appelé deux fois, l'onglet s'ouvrirait
    // puis se refermerait dans le même clic.
    // Le tracking est délégué au CTA de la carte (le <div> ne porte pas de data-cta-name,
    // donc le trackCta générique du haut de cette fonction ne voit rien) : même event
    // `location_alma` / `location_younited` que le clic direct, pas de nouveau nom à créer.
    var solutionCard = e.target.closest('[data-gl-loc-solution]');
    if (solutionCard && isMobileLayout() && !e.target.closest('[data-gl-loc-financing]')) {
      var cardTab = solutionCard.querySelector('[data-gl-loc-financing]');
      if (cardTab) {
        trackCta(modal, cardTab);
        openFinancing(modal, cardTab.getAttribute('data-gl-loc-financing'));
      }
      return;
    }
    // NB : submit + financing ne passent PAS par la délégation (comportement
    // incohérent observé en prod) : ils sont liés directement aux boutons dans
    // bindDirectControls() à l'ouverture — phase cible, incontournable.
  }

  // Liaison directe des CTA « Louer » et « En savoir plus » (posée à chaque
  // ouverture, idempotente par élément) : ne dépend d'aucune délégation.
  function bindDirectControls(modal) {
    var sb = modal.querySelector('[data-gl-loc-submit]');
    if (sb && !sb.__glLocBound) {
      sb.__glLocBound = true;
      sb.addEventListener('click', function () {
        submit(modal);
      });
    }
    Array.prototype.forEach.call(modal.querySelectorAll('[data-gl-loc-financing]'), function (fb) {
      if (fb.__glLocBound) return;
      fb.__glLocBound = true;
      fb.addEventListener('click', function () {
        openFinancing(modal, fb.getAttribute('data-gl-loc-financing'));
      });
    });

    var finSubmit = modal.querySelector('[data-gl-loc-fin-submit]');
    if (finSubmit && !finSubmit.__glLocBound) {
      finSubmit.__glLocBound = true;
      finSubmit.addEventListener('click', function () {
        goToCheckout(modal, finSubmit);
      });
    }
  }

  // Listeners délégués sur document (pas sur le nœud modale) : ils survivent aux
  // re-renders de la section produit ET n'ont pas besoin que la modale existe déjà.
  // Attachés une seule fois via un flag dédié — sans bloquer la ré-exécution du script.
  if (!window.__glLocDelegated) {
    window.__glLocDelegated = true;

    // Phase CAPTURE (true) : un handler de la page stoppe la propagation des clics
    // pendant la remontée (bubble) avant d'atteindre document. En capture, on s'exécute
    // en descente, donc toujours atteint quel que soit le stopPropagation de bubble.
    document.addEventListener('click', onModalClick, true);

    // Curseur d'apport : recalcule en direct pendant le glissement.
    document.addEventListener('input', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[data-gl-loc-apport-slider]')) return;
      var m = e.target.closest('.gl-loc-modal');
      if (m) recompute(m);
    });

    // Option assurance : seul endroit qui ouvre/ferme la ligne (transition CSS is-open,
    // ce qui fait glisser le reste), puis recalcule les montants.
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      var cb = e.target.closest('[data-gl-loc-insurance]');
      if (!cb) return;
      var m = cb.closest('.gl-loc-modal');
      if (!m) return;
      var line = m.querySelector('[data-gl-loc-line-insurance]');
      if (line) line.classList.toggle('is-open', cb.checked);
      recompute(m);
    });

    // Changement de variante : le prix change, donc toutes les offres de financement.
    // On purge les trois niveaux de mémoire (offres d'appel, offres Alma complètes,
    // et le cache du module qui garde la lecture de la modale Alma), puis on
    // repeuple les cartes si la modale est ouverte.
    document.addEventListener('variant:change', function () {
      headlineCache = { alma: null, younited: null };
      finSelection = { alma: null, younited: null };
      finRequested = { alma: null, younited: null };
      almaOffers = null;
      var fin = window.GreenleazeFinancing;
      if (fin && typeof fin.clearCache === 'function') fin.clearCache();

      var m = getModal();
      if (!m || m.hidden) return;
      // En vue accordéon on conserve le repli : changer de variante ne veut pas dire
      // « ouvre-moi la location ». Desktop inchangé.
      clearFinancing(m, barStaysVisible(m));
      syncOtherSolutions(m);
      // Les offres complètes d'Alma viennent d'être purgées : sans nouvelle lecture, sa
      // carte resterait sur le plan actif du widget replié jusqu'à la prochaine ouverture.
      prefetchAlma(m);
      watchOtherSolutions(m);
    });

    // Franchissement du seuil mobile pendant que la modale est ouverte (rotation d'un
    // téléphone ou d'une tablette) : l'accordéon n'existe qu'en dessous de 860px, la
    // visibilité du bandeau doit donc être réévaluée dans l'état courant — sinon il
    // resterait affiché en desktop, coincé entre la location dépliée et les autres
    // solutions. Gardé par le seuil lui-même : sur iOS la barre d'URL émet des `resize`
    // en rafale qui ne changent jamais de côté.
    var lastMobileLayout = isMobileLayout();
    window.addEventListener('resize', function () {
      if (isMobileLayout() === lastMobileLayout) return;
      lastMobileLayout = isMobileLayout();
      var m = getModal();
      if (!m || m.hidden) return;
      var lld = m.querySelector('[data-gl-loc-lld]');
      setLldCollapsed(m, !!lld && lld.classList.contains('is-collapsed'));
    });

    // Prix Greenleaze actualisés pendant que la modale est ouverte : on recalcule
    // les montants depuis la durée courante SANS réinitialiser les contrôles.
    window.addEventListener('greenleazePriceActualize', function () {
      var m = getModal();
      if (m && !m.hidden && m.dataset.glLocCurrentDuration) {
        recompute(m);
      }
    });
  }

  window.GreenleazeLocationModal = {
    open: open,
    close: close,
    isEnabledForDevice: function () {
      return isEnabledForDevice(getModal());
    },
  };
})();
